import { render } from "./SectionHeader.vue?vue&type=template&id=b321c410"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=b321c410&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script